import React, { useEffect, useState } from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { CHECKOUT_URL } from '../data/content';

/**
 * Sticky bottom CTA that appears once the user scrolls past the first hero CTA.
 */
export function FloatingCTA() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const anchor = document.getElementById('hero-cta');
    if (!anchor) return;
    const observer = new IntersectionObserver(([entry]) => {
      const passed = !entry.isIntersecting && entry.boundingClientRect.top < 0;
      setVisible(passed);
    }, {
      threshold: 0
    });
    observer.observe(anchor);
    return () => observer.disconnect();
  }, []);
  return <div className={`fixed inset-x-0 bottom-0 z-40 border-t border-gold/25 bg-ink/95 px-3 pb-[calc(0.65rem+env(safe-area-inset-bottom))] pt-2.5 backdrop-blur transition-[opacity,transform] duration-200 ease-out ${visible ? 'pointer-events-auto translate-y-0 opacity-100' : 'pointer-events-none translate-y-full opacity-0'}`} data-id="element-30" data-mp="2aw35kez4ufm3">
      <div className="mx-auto w-full max-w-lg" data-id="element-31" data-mp="2z4bq3czyyhsr">
        <a href={CHECKOUT_URL} tabIndex={visible ? 0 : -1} className="flex w-full animate-shake items-center justify-center gap-2 rounded-xl bg-gold px-4 py-3.5 text-[14px] font-extrabold uppercase tracking-wide text-ink shadow-[0_-6px_24px_-8px_rgba(200,162,76,0.6)] transition-[transform,background-color] duration-150 ease-out hover:bg-gold-light active:scale-[0.98] sm:text-base" data-id="element-32" data-mp="332htcb1lmf8x">
          Ottieni per 19 €
          <ArrowRightIcon className="h-4 w-4 shrink-0" aria-hidden="true" data-id="element-33" data-mp="26da3iqty5jz7" />
        </a>
        <p className="mt-1.5 text-center text-[10px] font-medium tracking-wide text-cream/50" data-id="element-34" data-mp="26fd0jutioddf">
          Pagamento unico · Download immediato · Garanzia 7 giorni
        </p>
      </div>
    </div>;
}